export default __webpack_public_path__ + "static/media/document.2f2a03f0.svg";